<template>
  <div v-if="store.projects">
    <form @submit.prevent="createProject">
      <select v-model="spaceId" class="rounded mr-2 w-full lg:w-2/5">
        <option v-for="space in store.spaces" :value="space.spaceId">
          {{ space.spaceName }}
        </option>
      </select>
      <input v-model="projectName" type="text" class="rounded mr-2 w-full lg:w-2/5" placeholder="Projekt">
      <input class="my-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" type="submit" value="vytvořit">
    </form>
  </div>
</template>

<script>
import {useNotificationStore} from "@/stores/notificationStore";
import {useAppStore} from "@/stores/appStore"

export default {
  name: "createProjectForm",
  data() {
    const store = useAppStore();
    return {
      projectName: "",
      api: null,
      store: store,
      spaceId: store.selectedProject.spaceId,
      spaces: null,
      notificationStore: useNotificationStore(),
    }
  },
  methods: {
    async createProject() {
      const data = {
        name: this.projectName,
        slug: this.store.toUrl(this.projectName),
        spaceId: this.spaceId
      }
      const project = await this.$projectsApi.createProject(this.spaceId, data).then(response => {
        this.spaceId = this.store.selectedProject.spaceId
        this.projectName = "";
        return response.data;
      }).catch(e => console.log(e));
      if (project) {
        this.notificationStore.success("projekt byl vytvořen");
        this.store.projects = await this.$usersApi.getUsersProjects().then(response => response.data);
      } else {
        this.notificationStore.error("projekt nebyl vytvořen");
      }
    },
    async findSpaces() {
      if (!this.store.projects) {
        this.store.projects =this.$usersApi.getUsersProjects().then(response => {
          return response.data;
        }).catch(e => {
          console.log(e);
        });
      }
    },
  },
  async created() {
    this.notificationStore.notify = this.$notify;
    this.findSpaces();
  }
}
</script>

<style scoped>

</style>